export const BAHAMAS_DESTINATION_CODE = 'BAHAM';
export const CARIBBEAN_DESTINATION_CODE = 'CARIB';
export const MIAMI_DESTINATION_CODE = 'MIA';
export const FORT_LAUDERDALE_DESTINATION_CODE = 'FLL';
